(() => {
  'use strict';
  const selector = '[data-rohrverbinder-selection]';
  const initialize = () => {
    const root = document.querySelector(selector);
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const base = root.dataset.collectionUrl;
    let pending = false;
    let queued;
    let renderer;
    const bindCartForms = () => {
      if (!window.theme?.AjaxProduct) return;
      root.querySelectorAll('[data-connector-cart-form]').forEach(form => {
        if (form.dataset.accessoryCartReady === 'true' || form.dataset.initialized) return;
        form.dataset.accessoryCartReady = 'true';
        new theme.AjaxProduct(form, '.add-to-cart');
      });
    };
    const disclosure = () => {
      const details = root.querySelector('[data-connector-disclosure]');
      if (details) details.open = !matchMedia('(max-width: 900px)').matches;
    };
    const load = async (url, updateHistory = true) => {
      if (pending) { queued = { url, updateHistory }; return; }
      if (!window.theme?.AjaxRenderer) { location.assign(url.href); return; }
      pending = true;
      root.setAttribute('aria-busy', 'true');
      const focused = document.activeElement;
      const focusId = focused?.id;
      const param = focused?.dataset.connectorParam;
      const value = focused?.dataset.connectorValue;
      const core = focused?.dataset.connectorCore;
      const wasOpen = root.querySelector('[data-connector-disclosure]')?.open;
      let valid = true;
      try {
        renderer ||= new theme.AjaxRenderer({
          sections: [{ sectionId: root.dataset.sectionId, nodeId: 'CollectionAjaxContent' }],
          onReplace: (dom, section) => {
            const content = dom.getElementById(section.nodeId);
            if (!content || content.textContent.includes('Liquid error')) { valid = false; return; }
            root.querySelector('#CollectionAjaxContent').innerHTML = content.innerHTML;
          }
        });
        renderer.getUpdatedParams = (_current, next) => new URLSearchParams(next);
        await renderer.renderPage(url.pathname, url.searchParams, false);
        if (!valid) { location.assign(url.href); return; }
        if (updateHistory) history.pushState({}, '', url.pathname + url.search);
        theme.sections.reinit('collection-template');
        theme.reinitProductGridItem();
        bindCartForms();
        const details = root.querySelector('[data-connector-disclosure]');
        if (details) details.open = wasOpen;
        const next = [...root.querySelectorAll('a,select')].find(el => focusId ? el.id === focusId : param ? el.dataset.connectorParam === param && el.dataset.connectorValue === value : core ? el.dataset.connectorCore === core : false);
        (next || root.querySelector('[data-connector-count]'))?.focus({ preventScroll: true });
        document.dispatchEvent(new CustomEvent('collection:reloaded'));
      } catch { location.assign(url.href); }
      finally {
        pending = false; root.removeAttribute('aria-busy');
        if (queued) { const next = queued; queued = null; load(next.url, next.updateHistory); }
      }
    };
    const tagUrl = (tag, removeOnly = false) => {
      const url = new URL(location.href);
      const tags = url.pathname.slice(base.length + 1).split('+').filter(Boolean);
      const kept = tags.filter(t => removeOnly ? t !== tag : !['mit-stahlkern', 'ohne-stahlkern'].includes(t));
      if (!removeOnly && !tags.includes(tag)) kept.push(tag);
      url.pathname = base + (kept.length ? '/' + kept.join('+') : '');
      url.searchParams.delete('page');
      return url;
    };
    root.addEventListener('click', event => {
      const link = event.target.closest('a');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (link.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; }
      if (!link.matches('[data-connector-param],[data-connector-core],[data-connector-link],[data-connector-remove-tag],[data-connector-reset]')) return;
      event.preventDefault();
      let url = new URL(link.href);
      if (link.dataset.connectorParam) {
        url = new URL(location.href);
        url.searchParams.delete(link.dataset.connectorParam);
        if (link.getAttribute('aria-pressed') !== 'true') url.searchParams.set(link.dataset.connectorParam, link.dataset.connectorValue);
      } else if (link.dataset.connectorCore) url = tagUrl(link.dataset.connectorCore);
      else if (link.dataset.connectorRemoveTag) url = tagUrl(link.dataset.connectorRemoveTag, true);
      else if (link.hasAttribute('data-connector-reset')) {
        url = new URL(location.href); url.pathname = base;
        [...url.searchParams.keys()].forEach(key => { if (key.startsWith('filter.') || key === 'page') url.searchParams.delete(key); });
      }
      url.searchParams.delete('page');
      load(url);
    });
    root.addEventListener('keydown', event => {
      if (event.key === ' ' && event.target.matches('a[role="button"]')) { event.preventDefault(); event.target.click(); }
    });
    root.addEventListener('change', event => {
      const target = event.target;
      if (!target.matches('[data-connector-select],[data-connector-sort]')) return;
      const url = new URL(location.href);
      const name = target.hasAttribute('data-connector-sort') ? 'sort_by' : target.name;
      url.searchParams.delete(name);
      if (target.value) url.searchParams.set(name, target.value);
      url.searchParams.delete('page'); load(url);
    });
    const onBack = () => load(new URL(location.href), false);
    window.addEventListener('popstate', onBack);
    const media = matchMedia('(max-width: 900px)');
    media.addEventListener('change', disclosure); disclosure();
    bindCartForms();
    const visibility = new IntersectionObserver(([entry]) => { root.dataset.inView = String(entry.isIntersecting); });
    visibility.observe(root);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) { visibility.disconnect(); media.removeEventListener('change', disclosure); window.removeEventListener('popstate', onBack); }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

